import { Component, OnInit, ViewEncapsulation, Input, HostListener } from "@angular/core";
import { DomSanitizer } from '@angular/platform-browser';
import { SharedService } from '../shared';
import { LANGUAGE_ENUM } from "../dateneingabe-frageboge/questionnaire.model";


@Component({
    selector: 'app-doc-check-login',
    templateUrl: "./doc-check-login.component.html",
    styleUrls: ["./doc-check-login.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class DocCheckLoginComponent implements OnInit {
    @Input() pageName: string = "";
    @Input() language: LANGUAGE_ENUM = LANGUAGE_ENUM.DE;

    LANGUAGE_ENUM = LANGUAGE_ENUM;

    DocCheckLoginType: 'login_xl' | 'login_l' | 'login_m' | 'login_s' = "login_xl";
    DocCheckLoginCode: string = "";
    get DocCheckLoginUrl() {
        return this.sanitizer.bypassSecurityTrustResourceUrl(`https://login.doccheck.com/code/de/${this.DocCheckLoginCode}/${this.DocCheckLoginType}/`);
    }

    get DocCheckWidth() {
        return this.DocCheckLoginType === 'login_xl' ? 467 :
            this.DocCheckLoginType === 'login_l' ? 424 :
                this.DocCheckLoginType === 'login_m' ? 311 :
                    156;
    }

    get DocCheckHeight() {
        return this.DocCheckLoginType === 'login_xl' ? 231 :
            this.DocCheckLoginType === 'login_l' ? 215 :
                this.DocCheckLoginType === 'login_m' ? 188 :
                    203;
    }

    get fullYear() {
        return new Date().getFullYear();
    }

    get headingName() {
        switch (this.pageName) {
            case 'dateneingabe':
                return "Zugang für medizinisches Fachpersonal";
            case 'datenebank':
                return "PEP-Suchseite";
            default:
                return "Doc Check Login";
        }
    }

    constructor(private sharedService: SharedService,
        private sanitizer: DomSanitizer) {
        this.getAPIConfig();
    }


    getAPIConfig() {
        this.sharedService.getAPIConfig().subscribe(
            res => {
                this.DocCheckLoginCode = this.pageName ? res[this.pageName] : null
                let name = this.pageName ? res[`${this.pageName}_LoginLogName`] : null;
                if (name) {
                    this.saveDocCheckLoginLogName(name);
                }
            }
        );
    }

    saveDocCheckLoginLogName(name) {
        if (name) {
            this.sharedService.saveDocCheckLoginLogName(name).subscribe();
        }
    }

    ngOnInit(): void {
        this.onWindowResize();
    }

    @HostListener('window:resize', ['$event'])
    onWindowResize(event = null) {
        if (this.language == LANGUAGE_ENUM.EN) {
            if (window.innerWidth < 320) {
                this.DocCheckLoginType = 'login_s';
            } else {
                this.DocCheckLoginType = 'login_m';
            }
        } else {
            if (window.innerWidth < 320) {
                this.DocCheckLoginType = 'login_s';
            } else if (window.innerWidth < 500) {
                this.DocCheckLoginType = 'login_m';
            } else if (window.innerWidth < 600) {
                this.DocCheckLoginType = 'login_l';
            } else {
                this.DocCheckLoginType = 'login_xl';
            }
        }
    }
}
